// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/user/v1/user.proto" (package "c1.api.user.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { AgentSearchService } from "./user";
import type { SearchAgentsResponse } from "./user";
import type { SearchAgentsRequest } from "./user";
import { AgentService } from "./user";
import type { ListAgentsResponse } from "./user";
import type { ListAgentsRequest } from "./user";
import type { DeleteAgentResponse } from "./user";
import type { DeleteAgentRequest } from "./user";
import type { SetAgentInstructionsResponse } from "./user";
import type { SetAgentInstructionsRequest } from "./user";
import type { GetAgentResponse } from "./user";
import type { GetAgentRequest } from "./user";
import type { CreateAgentResponse } from "./user";
import type { CreateAgentRequest } from "./user";
import { UserSearch } from "./user";
import type { GetDepartmentSearchTermsResponse } from "./user";
import type { GetDepartmentSearchTermsRequest } from "./user";
import type { GetJobTitleSearchTermsResponse } from "./user";
import type { GetJobTitleSearchTermsRequest } from "./user";
import type { GetEmploymentStatusSearchTermsResponse } from "./user";
import type { GetEmploymentStatusSearchTermsRequest } from "./user";
import type { SearchUserAttributesWithProfileTypeSourceResponse } from "./user";
import type { SearchUserAttributesWithProfileTypeSourceRequest } from "./user";
import type { StreamSearchUsersWithCELResponse } from "./user";
import type { StreamSearchUsersWithCELRequest } from "./user";
import type { ServerStreamingCall } from "@protobuf-ts/runtime-rpc";
import type { SearchUsersWithCELResponse } from "./user";
import type { SearchUsersWithCELRequest } from "./user";
import type { UsersWithUnspecifiedEmploymentStatusResponse } from "./user";
import type { UsersWithUnspecifiedEmploymentStatusRequest } from "./user";
import type { UsersWithoutManagerResponse } from "./user";
import type { UsersWithoutManagerRequest } from "./user";
import type { CountAppUsersWithoutManagerResponse } from "./user";
import type { CountAppUsersWithoutManagerRequest } from "./user";
import type { SearchManagedUsersForAccessRequestsResponse } from "./user";
import type { SearchManagedUsersForAccessRequestsRequest } from "./user";
import type { SearchManagedUsersResponse } from "./user";
import type { SearchManagedUsersRequest } from "./user";
import type { SearchUsersResponse } from "./user";
import type { SearchUsersRequest } from "./user";
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { UserService } from "./user";
import type { SetUserAvatarSelfResponse } from "./user";
import type { SetUserAvatarSelfRequest } from "./user";
import type { SetUserAvatarResponse } from "./user";
import type { SetUserAvatarRequest } from "./user";
import type { PreviewUserProfileWithProfileTypesResponse } from "./user";
import type { PreviewUserProfileWithProfileTypesRequest } from "./user";
import type { GetUserProfileTypesResponse } from "./user";
import type { GetUserProfileTypesRequest } from "./user";
import type { SetExpiringUserDelegationBindingSelfResponse } from "./user";
import type { SetExpiringUserDelegationBindingSelfRequest } from "./user";
import type { SetExpiringUserDelegationBindingByAdminResponse } from "./user";
import type { SetExpiringUserDelegationBindingByAdminRequest } from "./user";
import type { GetExpiringUserDelegationBindingResponse } from "./user";
import type { GetExpiringUserDelegationBindingRequest } from "./user";
import type { SetUserRolesRequest } from "./user";
import type { SetDelegatedUserRequest } from "./user";
import type { UpdateUserRequest } from "./user";
import type { UserServiceGetUsersByIDsResponse } from "./user";
import type { UserServiceGetUsersByIDsRequest } from "./user";
import type { UserServiceListResponse } from "./user";
import type { UserServiceListRequest } from "./user";
import type { UserServiceGetResponse } from "./user";
import type { UserServiceGetRequest } from "./user";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { IntrospectResponse } from "./user";
import type { IntrospectRequest } from "./user";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service c1.api.user.v1.UserService
 */
export interface IUserServiceClient {
    /**
     * @generated from protobuf rpc: Introspect
     */
    introspect(input: IntrospectRequest, options?: RpcOptions): UnaryCall<IntrospectRequest, IntrospectResponse>;
    /**
     * Get a user by ID.
     *
     * @generated from protobuf rpc: Get
     */
    get(input: UserServiceGetRequest, options?: RpcOptions): UnaryCall<UserServiceGetRequest, UserServiceGetResponse>;
    /**
     * List users.
     *
     * @generated from protobuf rpc: List
     */
    list(input: UserServiceListRequest, options?: RpcOptions): UnaryCall<UserServiceListRequest, UserServiceListResponse>;
    /**
     * @generated from protobuf rpc: GetByIDs
     */
    getByIDs(input: UserServiceGetUsersByIDsRequest, options?: RpcOptions): UnaryCall<UserServiceGetUsersByIDsRequest, UserServiceGetUsersByIDsResponse>;
    /**
     * @generated from protobuf rpc: Update
     */
    update(input: UpdateUserRequest, options?: RpcOptions): UnaryCall<UpdateUserRequest, UserServiceGetResponse>;
    /**
     * @generated from protobuf rpc: SetDelegatedUser
     */
    setDelegatedUser(input: SetDelegatedUserRequest, options?: RpcOptions): UnaryCall<SetDelegatedUserRequest, UserServiceGetResponse>;
    /**
     * @generated from protobuf rpc: SetUserRoles
     */
    setUserRoles(input: SetUserRolesRequest, options?: RpcOptions): UnaryCall<SetUserRolesRequest, UserServiceGetResponse>;
    /**
     * @generated from protobuf rpc: GetExpiringUserDelegationBinding
     */
    getExpiringUserDelegationBinding(input: GetExpiringUserDelegationBindingRequest, options?: RpcOptions): UnaryCall<GetExpiringUserDelegationBindingRequest, GetExpiringUserDelegationBindingResponse>;
    /**
     * @generated from protobuf rpc: SetExpiringUserDelegationBindingByAdmin
     */
    setExpiringUserDelegationBindingByAdmin(input: SetExpiringUserDelegationBindingByAdminRequest, options?: RpcOptions): UnaryCall<SetExpiringUserDelegationBindingByAdminRequest, SetExpiringUserDelegationBindingByAdminResponse>;
    /**
     * @generated from protobuf rpc: SetExpiringUserDelegationBindingSelf
     */
    setExpiringUserDelegationBindingSelf(input: SetExpiringUserDelegationBindingSelfRequest, options?: RpcOptions): UnaryCall<SetExpiringUserDelegationBindingSelfRequest, SetExpiringUserDelegationBindingSelfResponse>;
    /**
     * @generated from protobuf rpc: GetUserProfileTypes
     */
    getUserProfileTypes(input: GetUserProfileTypesRequest, options?: RpcOptions): UnaryCall<GetUserProfileTypesRequest, GetUserProfileTypesResponse>;
    /**
     * Preview what a user's profile would look like with a different set of ProfileTypes
     *
     * @generated from protobuf rpc: PreviewUserProfileWithProfileTypes
     */
    previewUserProfileWithProfileTypes(input: PreviewUserProfileWithProfileTypesRequest, options?: RpcOptions): UnaryCall<PreviewUserProfileWithProfileTypesRequest, PreviewUserProfileWithProfileTypesResponse>;
    /**
     * Set the avatar for a user. Admins and managers can set avatars for their users.
     *
     * @generated from protobuf rpc: SetUserAvatar
     */
    setUserAvatar(input: SetUserAvatarRequest, options?: RpcOptions): UnaryCall<SetUserAvatarRequest, SetUserAvatarResponse>;
    /**
     * Set the avatar for the current user (self).
     *
     * @generated from protobuf rpc: SetUserAvatarSelf
     */
    setUserAvatarSelf(input: SetUserAvatarSelfRequest, options?: RpcOptions): UnaryCall<SetUserAvatarSelfRequest, SetUserAvatarSelfResponse>;
}
/**
 * @generated from protobuf service c1.api.user.v1.UserService
 */
export class UserServiceClient implements IUserServiceClient, ServiceInfo {
    typeName = UserService.typeName;
    methods = UserService.methods;
    options = UserService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: Introspect
     */
    introspect(input: IntrospectRequest, options?: RpcOptions): UnaryCall<IntrospectRequest, IntrospectResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<IntrospectRequest, IntrospectResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Get a user by ID.
     *
     * @generated from protobuf rpc: Get
     */
    get(input: UserServiceGetRequest, options?: RpcOptions): UnaryCall<UserServiceGetRequest, UserServiceGetResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<UserServiceGetRequest, UserServiceGetResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * List users.
     *
     * @generated from protobuf rpc: List
     */
    list(input: UserServiceListRequest, options?: RpcOptions): UnaryCall<UserServiceListRequest, UserServiceListResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<UserServiceListRequest, UserServiceListResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetByIDs
     */
    getByIDs(input: UserServiceGetUsersByIDsRequest, options?: RpcOptions): UnaryCall<UserServiceGetUsersByIDsRequest, UserServiceGetUsersByIDsResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<UserServiceGetUsersByIDsRequest, UserServiceGetUsersByIDsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Update
     */
    update(input: UpdateUserRequest, options?: RpcOptions): UnaryCall<UpdateUserRequest, UserServiceGetResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateUserRequest, UserServiceGetResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SetDelegatedUser
     */
    setDelegatedUser(input: SetDelegatedUserRequest, options?: RpcOptions): UnaryCall<SetDelegatedUserRequest, UserServiceGetResponse> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<SetDelegatedUserRequest, UserServiceGetResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SetUserRoles
     */
    setUserRoles(input: SetUserRolesRequest, options?: RpcOptions): UnaryCall<SetUserRolesRequest, UserServiceGetResponse> {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept<SetUserRolesRequest, UserServiceGetResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetExpiringUserDelegationBinding
     */
    getExpiringUserDelegationBinding(input: GetExpiringUserDelegationBindingRequest, options?: RpcOptions): UnaryCall<GetExpiringUserDelegationBindingRequest, GetExpiringUserDelegationBindingResponse> {
        const method = this.methods[7], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetExpiringUserDelegationBindingRequest, GetExpiringUserDelegationBindingResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SetExpiringUserDelegationBindingByAdmin
     */
    setExpiringUserDelegationBindingByAdmin(input: SetExpiringUserDelegationBindingByAdminRequest, options?: RpcOptions): UnaryCall<SetExpiringUserDelegationBindingByAdminRequest, SetExpiringUserDelegationBindingByAdminResponse> {
        const method = this.methods[8], opt = this._transport.mergeOptions(options);
        return stackIntercept<SetExpiringUserDelegationBindingByAdminRequest, SetExpiringUserDelegationBindingByAdminResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SetExpiringUserDelegationBindingSelf
     */
    setExpiringUserDelegationBindingSelf(input: SetExpiringUserDelegationBindingSelfRequest, options?: RpcOptions): UnaryCall<SetExpiringUserDelegationBindingSelfRequest, SetExpiringUserDelegationBindingSelfResponse> {
        const method = this.methods[9], opt = this._transport.mergeOptions(options);
        return stackIntercept<SetExpiringUserDelegationBindingSelfRequest, SetExpiringUserDelegationBindingSelfResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetUserProfileTypes
     */
    getUserProfileTypes(input: GetUserProfileTypesRequest, options?: RpcOptions): UnaryCall<GetUserProfileTypesRequest, GetUserProfileTypesResponse> {
        const method = this.methods[10], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetUserProfileTypesRequest, GetUserProfileTypesResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Preview what a user's profile would look like with a different set of ProfileTypes
     *
     * @generated from protobuf rpc: PreviewUserProfileWithProfileTypes
     */
    previewUserProfileWithProfileTypes(input: PreviewUserProfileWithProfileTypesRequest, options?: RpcOptions): UnaryCall<PreviewUserProfileWithProfileTypesRequest, PreviewUserProfileWithProfileTypesResponse> {
        const method = this.methods[11], opt = this._transport.mergeOptions(options);
        return stackIntercept<PreviewUserProfileWithProfileTypesRequest, PreviewUserProfileWithProfileTypesResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Set the avatar for a user. Admins and managers can set avatars for their users.
     *
     * @generated from protobuf rpc: SetUserAvatar
     */
    setUserAvatar(input: SetUserAvatarRequest, options?: RpcOptions): UnaryCall<SetUserAvatarRequest, SetUserAvatarResponse> {
        const method = this.methods[12], opt = this._transport.mergeOptions(options);
        return stackIntercept<SetUserAvatarRequest, SetUserAvatarResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * Set the avatar for the current user (self).
     *
     * @generated from protobuf rpc: SetUserAvatarSelf
     */
    setUserAvatarSelf(input: SetUserAvatarSelfRequest, options?: RpcOptions): UnaryCall<SetUserAvatarSelfRequest, SetUserAvatarSelfResponse> {
        const method = this.methods[13], opt = this._transport.mergeOptions(options);
        return stackIntercept<SetUserAvatarSelfRequest, SetUserAvatarSelfResponse>("unary", this._transport, method, opt, input);
    }
}
/**
 * @generated from protobuf service c1.api.user.v1.UserSearch
 */
export interface IUserSearchClient {
    /**
     * Search users based on filters specified in the request body.
     *
     * @generated from protobuf rpc: Search
     */
    search(input: SearchUsersRequest, options?: RpcOptions): UnaryCall<SearchUsersRequest, SearchUsersResponse>;
    /**
     * @generated from protobuf rpc: SearchManagedUsers
     */
    searchManagedUsers(input: SearchManagedUsersRequest, options?: RpcOptions): UnaryCall<SearchManagedUsersRequest, SearchManagedUsersResponse>;
    /**
     * @generated from protobuf rpc: SearchManagedUsersForAccessRequests
     */
    searchManagedUsersForAccessRequests(input: SearchManagedUsersForAccessRequestsRequest, options?: RpcOptions): UnaryCall<SearchManagedUsersForAccessRequestsRequest, SearchManagedUsersForAccessRequestsResponse>;
    /**
     * @generated from protobuf rpc: CountAppUsersWithoutManager
     */
    countAppUsersWithoutManager(input: CountAppUsersWithoutManagerRequest, options?: RpcOptions): UnaryCall<CountAppUsersWithoutManagerRequest, CountAppUsersWithoutManagerResponse>;
    /**
     * @generated from protobuf rpc: UsersWithoutManager
     */
    usersWithoutManager(input: UsersWithoutManagerRequest, options?: RpcOptions): UnaryCall<UsersWithoutManagerRequest, UsersWithoutManagerResponse>;
    /**
     * @generated from protobuf rpc: SearchUsersWithUnspecifiedEmploymentStatus
     */
    searchUsersWithUnspecifiedEmploymentStatus(input: UsersWithUnspecifiedEmploymentStatusRequest, options?: RpcOptions): UnaryCall<UsersWithUnspecifiedEmploymentStatusRequest, UsersWithUnspecifiedEmploymentStatusResponse>;
    /**
     * @generated from protobuf rpc: SearchWithCEL
     */
    searchWithCEL(input: SearchUsersWithCELRequest, options?: RpcOptions): UnaryCall<SearchUsersWithCELRequest, SearchUsersWithCELResponse>;
    /**
     * StreamSearchWithCEL searches users with a CEL expression using a streaming response.
     * Unlike SearchWithCEL, this correctly evaluates ALL users against the expression
     * before applying pagination, ensuring accurate results.
     *
     * @generated from protobuf rpc: StreamSearchWithCEL
     */
    streamSearchWithCEL(input: StreamSearchUsersWithCELRequest, options?: RpcOptions): ServerStreamingCall<StreamSearchUsersWithCELRequest, StreamSearchUsersWithCELResponse>;
    /**
     * @generated from protobuf rpc: SearchUserAttributesWithProfileTypeSource
     */
    searchUserAttributesWithProfileTypeSource(input: SearchUserAttributesWithProfileTypeSourceRequest, options?: RpcOptions): UnaryCall<SearchUserAttributesWithProfileTypeSourceRequest, SearchUserAttributesWithProfileTypeSourceResponse>;
    /**
     * @generated from protobuf rpc: GetEmploymentStatusSearchTerms
     */
    getEmploymentStatusSearchTerms(input: GetEmploymentStatusSearchTermsRequest, options?: RpcOptions): UnaryCall<GetEmploymentStatusSearchTermsRequest, GetEmploymentStatusSearchTermsResponse>;
    /**
     * @generated from protobuf rpc: GetJobTitleSearchTerms
     */
    getJobTitleSearchTerms(input: GetJobTitleSearchTermsRequest, options?: RpcOptions): UnaryCall<GetJobTitleSearchTermsRequest, GetJobTitleSearchTermsResponse>;
    /**
     * @generated from protobuf rpc: GetDepartmentSearchTerms
     */
    getDepartmentSearchTerms(input: GetDepartmentSearchTermsRequest, options?: RpcOptions): UnaryCall<GetDepartmentSearchTermsRequest, GetDepartmentSearchTermsResponse>;
}
/**
 * @generated from protobuf service c1.api.user.v1.UserSearch
 */
export class UserSearchClient implements IUserSearchClient, ServiceInfo {
    typeName = UserSearch.typeName;
    methods = UserSearch.methods;
    options = UserSearch.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * Search users based on filters specified in the request body.
     *
     * @generated from protobuf rpc: Search
     */
    search(input: SearchUsersRequest, options?: RpcOptions): UnaryCall<SearchUsersRequest, SearchUsersResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchUsersRequest, SearchUsersResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchManagedUsers
     */
    searchManagedUsers(input: SearchManagedUsersRequest, options?: RpcOptions): UnaryCall<SearchManagedUsersRequest, SearchManagedUsersResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchManagedUsersRequest, SearchManagedUsersResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchManagedUsersForAccessRequests
     */
    searchManagedUsersForAccessRequests(input: SearchManagedUsersForAccessRequestsRequest, options?: RpcOptions): UnaryCall<SearchManagedUsersForAccessRequestsRequest, SearchManagedUsersForAccessRequestsResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchManagedUsersForAccessRequestsRequest, SearchManagedUsersForAccessRequestsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CountAppUsersWithoutManager
     */
    countAppUsersWithoutManager(input: CountAppUsersWithoutManagerRequest, options?: RpcOptions): UnaryCall<CountAppUsersWithoutManagerRequest, CountAppUsersWithoutManagerResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<CountAppUsersWithoutManagerRequest, CountAppUsersWithoutManagerResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UsersWithoutManager
     */
    usersWithoutManager(input: UsersWithoutManagerRequest, options?: RpcOptions): UnaryCall<UsersWithoutManagerRequest, UsersWithoutManagerResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<UsersWithoutManagerRequest, UsersWithoutManagerResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchUsersWithUnspecifiedEmploymentStatus
     */
    searchUsersWithUnspecifiedEmploymentStatus(input: UsersWithUnspecifiedEmploymentStatusRequest, options?: RpcOptions): UnaryCall<UsersWithUnspecifiedEmploymentStatusRequest, UsersWithUnspecifiedEmploymentStatusResponse> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<UsersWithUnspecifiedEmploymentStatusRequest, UsersWithUnspecifiedEmploymentStatusResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchWithCEL
     */
    searchWithCEL(input: SearchUsersWithCELRequest, options?: RpcOptions): UnaryCall<SearchUsersWithCELRequest, SearchUsersWithCELResponse> {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchUsersWithCELRequest, SearchUsersWithCELResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * StreamSearchWithCEL searches users with a CEL expression using a streaming response.
     * Unlike SearchWithCEL, this correctly evaluates ALL users against the expression
     * before applying pagination, ensuring accurate results.
     *
     * @generated from protobuf rpc: StreamSearchWithCEL
     */
    streamSearchWithCEL(input: StreamSearchUsersWithCELRequest, options?: RpcOptions): ServerStreamingCall<StreamSearchUsersWithCELRequest, StreamSearchUsersWithCELResponse> {
        const method = this.methods[7], opt = this._transport.mergeOptions(options);
        return stackIntercept<StreamSearchUsersWithCELRequest, StreamSearchUsersWithCELResponse>("serverStreaming", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SearchUserAttributesWithProfileTypeSource
     */
    searchUserAttributesWithProfileTypeSource(input: SearchUserAttributesWithProfileTypeSourceRequest, options?: RpcOptions): UnaryCall<SearchUserAttributesWithProfileTypeSourceRequest, SearchUserAttributesWithProfileTypeSourceResponse> {
        const method = this.methods[8], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchUserAttributesWithProfileTypeSourceRequest, SearchUserAttributesWithProfileTypeSourceResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetEmploymentStatusSearchTerms
     */
    getEmploymentStatusSearchTerms(input: GetEmploymentStatusSearchTermsRequest, options?: RpcOptions): UnaryCall<GetEmploymentStatusSearchTermsRequest, GetEmploymentStatusSearchTermsResponse> {
        const method = this.methods[9], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetEmploymentStatusSearchTermsRequest, GetEmploymentStatusSearchTermsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetJobTitleSearchTerms
     */
    getJobTitleSearchTerms(input: GetJobTitleSearchTermsRequest, options?: RpcOptions): UnaryCall<GetJobTitleSearchTermsRequest, GetJobTitleSearchTermsResponse> {
        const method = this.methods[10], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetJobTitleSearchTermsRequest, GetJobTitleSearchTermsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetDepartmentSearchTerms
     */
    getDepartmentSearchTerms(input: GetDepartmentSearchTermsRequest, options?: RpcOptions): UnaryCall<GetDepartmentSearchTermsRequest, GetDepartmentSearchTermsResponse> {
        const method = this.methods[11], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetDepartmentSearchTermsRequest, GetDepartmentSearchTermsResponse>("unary", this._transport, method, opt, input);
    }
}
/**
 * @generated from protobuf service c1.api.user.v1.AgentService
 */
export interface IAgentServiceClient {
    /**
     * @generated from protobuf rpc: CreateAgent
     */
    createAgent(input: CreateAgentRequest, options?: RpcOptions): UnaryCall<CreateAgentRequest, CreateAgentResponse>;
    /**
     * @generated from protobuf rpc: GetAgent
     */
    getAgent(input: GetAgentRequest, options?: RpcOptions): UnaryCall<GetAgentRequest, GetAgentResponse>;
    /**
     * @generated from protobuf rpc: SetAgentInstructions
     */
    setAgentInstructions(input: SetAgentInstructionsRequest, options?: RpcOptions): UnaryCall<SetAgentInstructionsRequest, SetAgentInstructionsResponse>;
    /**
     * @generated from protobuf rpc: DeleteAgent
     */
    deleteAgent(input: DeleteAgentRequest, options?: RpcOptions): UnaryCall<DeleteAgentRequest, DeleteAgentResponse>;
    /**
     * @generated from protobuf rpc: ListAgents
     */
    listAgents(input: ListAgentsRequest, options?: RpcOptions): UnaryCall<ListAgentsRequest, ListAgentsResponse>;
}
/**
 * @generated from protobuf service c1.api.user.v1.AgentService
 */
export class AgentServiceClient implements IAgentServiceClient, ServiceInfo {
    typeName = AgentService.typeName;
    methods = AgentService.methods;
    options = AgentService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: CreateAgent
     */
    createAgent(input: CreateAgentRequest, options?: RpcOptions): UnaryCall<CreateAgentRequest, CreateAgentResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<CreateAgentRequest, CreateAgentResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetAgent
     */
    getAgent(input: GetAgentRequest, options?: RpcOptions): UnaryCall<GetAgentRequest, GetAgentResponse> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<GetAgentRequest, GetAgentResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SetAgentInstructions
     */
    setAgentInstructions(input: SetAgentInstructionsRequest, options?: RpcOptions): UnaryCall<SetAgentInstructionsRequest, SetAgentInstructionsResponse> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<SetAgentInstructionsRequest, SetAgentInstructionsResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeleteAgent
     */
    deleteAgent(input: DeleteAgentRequest, options?: RpcOptions): UnaryCall<DeleteAgentRequest, DeleteAgentResponse> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<DeleteAgentRequest, DeleteAgentResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: ListAgents
     */
    listAgents(input: ListAgentsRequest, options?: RpcOptions): UnaryCall<ListAgentsRequest, ListAgentsResponse> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<ListAgentsRequest, ListAgentsResponse>("unary", this._transport, method, opt, input);
    }
}
/**
 * @generated from protobuf service c1.api.user.v1.AgentSearchService
 */
export interface IAgentSearchServiceClient {
    /**
     * @generated from protobuf rpc: Search
     */
    search(input: SearchAgentsRequest, options?: RpcOptions): UnaryCall<SearchAgentsRequest, SearchAgentsResponse>;
}
/**
 * @generated from protobuf service c1.api.user.v1.AgentSearchService
 */
export class AgentSearchServiceClient implements IAgentSearchServiceClient, ServiceInfo {
    typeName = AgentSearchService.typeName;
    methods = AgentSearchService.methods;
    options = AgentSearchService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: Search
     */
    search(input: SearchAgentsRequest, options?: RpcOptions): UnaryCall<SearchAgentsRequest, SearchAgentsResponse> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<SearchAgentsRequest, SearchAgentsResponse>("unary", this._transport, method, opt, input);
    }
}
